import _ from 'lodash';
import { NavigationTree, NavTreeItem } from '../domains/navigationTree.domain';
import { get } from './core/fetch';

export const transformNavigationTree = (
	navMenu: any,
	licenseeTypes: string[]
): NavigationTree => {
	function getSubPages(subpages: any): any {
		return _(subpages)
			.map(key => {
				const keyValueArray: any = _.toPairs(key)[0];
				let keyedMenuItem: any;
				keyedMenuItem = keyValueArray[1];
				keyedMenuItem.key = keyValueArray[0];
				return keyedMenuItem;
			})
			.filter((item: any) => !item.hideInNav)
			.map((item: any) => {
				return {
					key: item.key,
					url: item.pageurl,
					title: item['jcr:title'],
					subpages: getSubPages(item.subpages),
					licenseeName: item.licenseeName,
				} as NavTreeItem;
			})
			.value();
	}
	const menuItems = getSubPages(navMenu.subpages);

	const menuData = _.filter(menuItems, item => !item.licenseeName);
	const homeLink = _.find(menuItems, item => item.title === 'Home');
	const licenseeMenu = _.find(menuItems, item =>
		_.includes(licenseeTypes, item.licenseeName)
	);

	return {
		menuData,
		homeLink: homeLink ? homeLink.url : '/',
		licenseeMenu,
	};
};

export const getNavigationTree = async (
	licenseeTypes: string[]
): Promise<NavigationTree> => {
	const params =
		'tidy=true&treenest=true&dumpproperties=pageRoute,hideInNav,navTitle,jcr:title,pageurl,redirectTarget,licenseeName&ignoreproperties=sling:resourceType,jcr:created';
	const data = await get(`/secure/adviser.nabfeed.content.2.json?${params}`, {
		withAuth: true,
	});
	return transformNavigationTree(data, licenseeTypes);
};
